import { render, staticRenderFns } from "./MPAGasFreeInspectionFees.vue?vue&type=template&id=70bc2714&"
import script from "./MPAGasFreeInspectionFees.vue?vue&type=script&lang=js&"
export * from "./MPAGasFreeInspectionFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports